import { AfterViewInit, Component, effect, ElementRef, inject, output, signal, ViewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NewsCategoryService } from '../news-category.service';
import { NewsCategoryPipe } from '../news-category.pipe';

@Component({
  selector: 'app-category-list',
  imports: [
    TranslatePipe,
    NewsCategoryPipe
  ],
  templateUrl: './category-list.component.html',
  styleUrl: './category-list.component.sass'
})
export class CategoryListComponent implements AfterViewInit {
  private newsCategoryService = inject(NewsCategoryService);

  activeIndex = 0;

  selectedCategoryId = signal<string | null>(null);

  categorySelected = output<string | null>();

  // Sorted by Dutch name, whatever the language
  categories = this.newsCategoryService.categories;

  @ViewChild('scroller', { static: true }) scroller!: ElementRef<HTMLDivElement>;

  atStart = true;
  atEnd = false;

  constructor() {
    this.newsCategoryService.load();

    // The categories arrive after the first render, and a language change swaps their names; either
    // changes how far the list scrolls.
    effect(() => {
      this.categories();
      setTimeout(() => this.updateArrows());
    });
  }
  
  ngAfterViewInit() {
    this.updateArrows();
  }
  
  scroll(amount: number) {
    this.scroller.nativeElement.scrollBy({ left: amount, behavior: 'smooth' });
    // schedule update for arrow state after smooth scroll
    setTimeout(() => this.updateArrows(), 250);
  }
  
  onScroll() {
    this.updateArrows();
  }

  setActive(i: number) {
    this.activeIndex = i;
  }

  onKeydown(event: KeyboardEvent) {
    const key = event.key;
    if (key === 'ArrowRight') { event.preventDefault(); this.move(1); }
    else if (key === 'ArrowLeft') { event.preventDefault(); this.move(-1); }
    else if (key === 'Home') { event.preventDefault(); this.moveTo(0); }
    else if (key === 'End') { event.preventDefault(); this.moveTo(this.categories().length); }
  }

  private move(delta: number) {
    const len = this.categories().length + 1; // +1 for 'All' category
    this.moveTo((this.activeIndex + delta + len) % len);
  }

  private moveTo(i: number) {
    this.activeIndex = i;
    const btn = this.scroller.nativeElement.querySelector(`#category-${i}`) as HTMLElement | null;
    if (btn) {
      btn.focus();
      btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
    this.updateArrows();
  }

  select(categoryId: string | null) {
    this.selectedCategoryId.set(categoryId);
    this.categorySelected.emit(categoryId);
  }
  
  private updateArrows() {
    const el = this.scroller.nativeElement;
    this.atStart = el.scrollLeft <= 0;
    this.atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
  }

}
